import React from 'react';
import styled from 'styled-components';

import { Typography, Slide, Switch, IconButton } from '@material-ui/core/';
import CloseIcon from '@material-ui/icons/Close';

import { CustomSwitch } from './data/flowGraphData';

/* eslint-disable indent */
const Root = styled(CustomSwitch)`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: ${(props) =>
		props.theme.palette.blocks.graph.overlay.backgroundColor};
	z-index: 999;

	.panel-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;

		h6 {
			font-size: 16px;
			font-weight: bold;
			text-transform: uppercase;
		}
	}

	.panel-content {
		margin-top: 40px;

		button {
			padding: 0;
			background-color: transparent;
			border: 0;
			font-size: 16px;
			font-family: ${(props) => props.theme.typography.fontFamily};
			color: ${(props) => props.theme.palette.text.primary};
			cursor: pointer;
		}

		.panel-content__item {
			display: flex;
			align-items: center;
			padding: 10px;

			&.is-active {
				background-color: ${(props) =>
					props.theme.palette.blocks.graph.overlay.backgroundColorActive};
			}
		}
	}

	.MuiIconButton-root {
		color: ${(props) => props.theme.palette.text.primary};
	}
`;

const GraphOverLay = ({
	SlideIn,
	switchData,
	toggleClose,
	toggleLeftPanel,
	toggleGraphData,
	toggleActiveSelection,
	activeSelected,
}) => (
	<Slide direction="left" in={SlideIn} mountOnEnter>
		<Root>
			<div className="panel-head">
				<Typography variant="h6">Systemkomponenten</Typography>
				<IconButton
					onClick={() => {
						toggleClose();
						toggleActiveSelection(null);
					}}
				>
					<CloseIcon />
				</IconButton>
			</div>
			<div className="panel-content">
				{switchData.map((item, key) => (
					<div
						className={`panel-content__item${
							key === activeSelected ? ' is-active' : ''
						}`}
						key={key}
					>
						<Switch
							defaultChecked
							className={`switch-color is-${item.colorName}`}
							onClick={() => {
								toggleGraphData(item.dataKey);
							}}
							value={item.key}
						/>
						<button
							type="button"
							onClick={() => {
								toggleLeftPanel(item.name);
								toggleActiveSelection(key);
							}}
						>
							{item.name}
						</button>
					</div>
				))}
			</div>
		</Root>
	</Slide>
);

export default GraphOverLay;
